import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IProperties } from '../../../builder/types';

interface IFillingHeadingProps {
  properties: IProperties,
}

export const FillingHeading: React.FC<IFillingHeadingProps> = ({ properties }) => {
  return (
    <>
      <Heading style={{userSelect: 'none'}}>{`${((properties || {}).params || {}).question || 'Title'}`}</Heading>
    </>);
}